import { UserChats } from './UserChats'

// eslint-disable-next-line import/no-default-export
export default UserChats
